import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import EmbeddedPageFrame from '../common/ui/EmbeddedPageFrame';
import { AiModelTab } from './aiModelConfig/AiModelTab';

export class AiModelSection extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    activeModelType: 'OPEN_AI',
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  switchAIModelTypeTab = (tab) => {
    const { activeModelType } = this.state;
    if (activeModelType !== tab) {
      this.setState({ activeModelType: tab });
    }
  };

  render() {
    const { appSetting, match, actions } = this.props;
    const { projectDetail } = appSetting;
    const { projectId, version } = match.params;
    if (!projectDetail) {
      return '';
    }
    const { environments } = projectDetail;
    return (
      <EmbeddedPageFrame
        embedded={this.props.embedded}
        nav={<AppSettingsNav activeTab={'aiModelConfig'} projectDetail={projectDetail} />}
      >
        <AiModelTab
          projectDetail={projectDetail}
          environments={environments}
          projectId={projectId}
          version={version}
          updateAiModelConfig={actions.updateAiModelConfig}
          activeModelType={this.state.activeModelType}
          switchAIModelTypeTab={this.switchAIModelTypeTab}
        />
      </EmbeddedPageFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AiModelSection);
